export default "__VITE_ASSET__DWaALSKX__"